import { render, staticRenderFns } from "./AskSuggestedQuestions.vue?vue&type=template&id=678d9883&scoped=true&"
import script from "./AskSuggestedQuestions.vue?vue&type=script&lang=js&"
export * from "./AskSuggestedQuestions.vue?vue&type=script&lang=js&"
import style0 from "./AskSuggestedQuestions.vue?vue&type=style&index=0&id=678d9883&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d9883",
  null
  
)

export default component.exports